/**
 * RBAC Module Constants
 * Source: rbac_modules table
 * Synced with backend: basiq360_product_backend/src/constants/modules.constants.ts
 */

export const MODULE_ID = {
  DROPDOWN_MANAGEMENT: 13,
  ANALYTICS: 100,
  SFA_ANALYTICS: 101,
  PRIMARY_CUSTOMER: 102,
  PRIMARY_ORDER: 103,
  PRODUCT_MASTER: 104,
  SALES_USER: 105,
  ROLE: 106,
  LMS_ANALYTICS: 107,
  LEAD: 108,
  SECONDARY_CUSTOMER: 109,
  SECONDARY_ORDER: 110,
  PRODUCT_PRICE: 111,
  BACKEND_USER: 112,
  PERMISSION: 113,
  IRP_ANALYTICS: 114,
  SITES: 115,
  DIRECT_NETWORK: 116,
  TERTIARY_ORDER: 117,
  PRODUCT_DISCOUNT: 118,
  // PRODUCT_VARIANT: 148, // Deprecated - Variants removed from system
  CUSTOMER_NETWORK: 119,
  INFLUENCER_CUSTOMER: 120,
  ORDERS: 122,
  QUOTATION: 123,
  ACCOUNTS: 124,
  ATTENDANCE: 125,
  MAP: 126,
  ACTIVITY: 127,
  LEAVE: 128,
  BEAT_PLAN: 129,
  FOLLOW_UP: 130,
  EXPENSE: 131,
  EVENT_PLAN: 132,
  POP_GIFT: 133,
  SURVEY: 134,
  TASK: 135,
  SUPPORT: 136,
  TARGET: 137,
  PRODUCT: 138,
  USER: 139,
  ROLE_PERMISSION: 140,
  SESSION_MANAGEMENT: 141,
  HOLIDAY: 142,
  CHAT: 143,
  REPORT: 144,
  APP_CONFIG: 145,
  POSTAL: 146,
  KEYBOARD_SHORTCUT: 147,
  ENQUIRY: 149,
} as const;

export const MODULE_NAMES: Record<number, string> = {
  13: 'Dropdown Management',
  100: 'Analytics',
  101: 'Sales Force Automation',
  102: 'Primary Customer',
  103: 'Primary',
  104: 'Product',
  105: 'Sales',
  106: 'Role',
  107: 'Lead Management System',
  108: 'Lead',
  109: 'Secondary Customer',
  110: 'Secondary',
  111: 'Product Price',
  112: 'Backend',
  113: 'Permission',
  114: 'Influencer Reward Program',
  115: 'Sites',
  116: 'Direct Network',
  117: 'Tertiary',
  118: 'Product Discount',
  // 148: 'Product Variant', // Deprecated - Variants removed from system
  119: 'Customer Network',
  120: 'Influencer Customer',
  // 121: 'End Customer', // Soft deleted - no longer in use
  122: 'Orders',
  123: 'Quotation',
  124: 'Accounts',
  125: 'Attendance',
  126: 'Map',
  127: 'Activity',
  128: 'Leave',
  129: 'Beat Plan',
  130: 'Follow Up',
  131: 'Expense',
  132: 'Event Plan',
  133: 'Pop-Gift',
  134: 'Survey',
  135: 'Task',
  136: 'Support',
  137: 'Target',
  138: 'Product',
  139: 'User',
  140: 'Role-Permission',
  141: 'Session Management',
  142: 'Holiday',
  143: 'Chat',
  144: 'Report',
  145: 'App Config',
  146: 'Postal',
  147: 'Keyboard Shortcut',
  149: 'Enquiry',
};

export const MODULE_CODES: Record<number, string> = {
  13: 'DROPDOWN_MANAGEMENT',
  100: 'ANALYTICS',
  101: 'SFA_ANALYTICS',
  102: 'PRIMARY_CUSTOMER',
  103: 'PRIMARY_ORDER',
  104: 'PRODUCT_MASTER',
  105: 'SALES_USER',
  106: 'ROLE',
  107: 'LMS_ANALYTICS',
  108: 'LEAD',
  109: 'SECONDARY_CUSTOMER',
  110: 'SECONDARY_ORDER',
  111: 'PRODUCT_PRICE',
  112: 'BACKEND_USER',
  113: 'PERMISSION',
  114: 'IRP_ANALYTICS',
  115: 'SITES',
  116: 'DIRECT_NETWORK',
  117: 'TERTIARY_ORDER',
  118: 'PRODUCT_DISCOUNT',
  // 148: 'PRODUCT_VARIANT', // Deprecated - Variants removed from system
  119: 'CUSTOMER_NETWORK',
  120: 'INFLUENCER_CUSTOMER',
  122: 'ORDERS',
  123: 'QUOTATION',
  124: 'ACCOUNTS',
  125: 'ATTENDANCE',
  126: 'MAP',
  127: 'ACTIVITY',
  128: 'LEAVE',
  129: 'BEAT_PLAN',
  130: 'FOLLOW_UP',
  131: 'EXPENSE',
  132: 'EVENT_PLAN',
  133: 'POP_GIFT',
  134: 'SURVEY',
  135: 'TASK',
  136: 'SUPPORT',
  137: 'TARGET',
  138: 'PRODUCT',
  139: 'USER',
  140: 'ROLE_PERMISSION',
  141: 'SESSION_MANAGEMENT',
  142: 'HOLIDAY',
  143: 'CHAT',
  144: 'REPORT',
  145: 'APP_CONFIG',
  146: 'POSTAL',
  147: 'KEYBOARD_SHORTCUT',
  149: 'ENQUIRY',
};

// Type for Module ID values
export type ModuleIdValue = typeof MODULE_ID[keyof typeof MODULE_ID];
